<template>
  <div class="flex min-h-dvh w-full flex-col">
    <!--TODO: make whole component way better -->
    <!-- <BlankHeader /> -->
    <div class="flex flex-1 items-center justify-center"><slot></slot></div>
  </div>
</template>

<!-- <script setup lang="ts">
import BlankHeader from './components/BlankHeader.vue';
</script> -->
